(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.YISETemporarySalePrice = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  function cents(value) {
    if (value === null || value === undefined || value === '') return null;
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function number(value) {
    if (value === null || value === undefined || value === '') return null;
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function timestamp(value) {
    if (!value) return null;
    var parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function currentTime(now) {
    if (now instanceof Date) return now.getTime();
    if (typeof now === 'number') return now;
    return Date.now();
  }

  function hasDiscount(explicitPrice, discountType, discountValue) {
    if (cents(explicitPrice) !== null) return true;

    var value = number(discountValue);
    return value !== null && value > 0 && (discountType === 'percentage' || discountType === 'amount');
  }

  function hasTemporarySaleDiscount(sale) {
    if (!sale) return false;
    return hasDiscount(sale.price, sale.discountType, sale.discountValue);
  }

  function hasSubscriptionSaleDiscount(sale) {
    if (!sale) return false;
    return hasDiscount(sale.subscriptionPrice, sale.subscriptionDiscountType, sale.subscriptionDiscountValue);
  }

  function isRuntimePreview() {
    if (typeof window === 'undefined') return false;

    if (window.Shopify && (window.Shopify.designMode === true || window.Shopify.visualPreviewMode === true)) {
      return true;
    }

    if (window.location && window.location.hostname.indexOf('shopifypreview.com') > -1) {
      return true;
    }

    try {
      var params = new URLSearchParams(window.location.search);
      return ['preview', 'preview_email', 'email_preview'].some(function (key) {
        return String(params.get(key) || '').toLowerCase() === 'true';
      });
    } catch (error) {
      return false;
    }
  }

  function isWithinSaleWindow(sale, now) {
    if (!sale) return false;
    if (sale.tester === true) return true;
    if (sale.preview === true || isRuntimePreview()) return true;
    if (sale.active === false) return false;

    var nowMs = currentTime(now);
    var startMs = timestamp(sale.startTime);
    var endMs = timestamp(sale.endTime);

    if (startMs !== null && nowMs < startMs) return false;
    if (endMs !== null && nowMs >= endMs) return false;

    return sale.active === true || startMs !== null || endMs !== null;
  }

  function isTemporarySaleActive(sale, now) {
    return hasTemporarySaleDiscount(sale) && isWithinSaleWindow(sale, now);
  }

  function isSubscriptionSaleActive(sale, now) {
    return hasSubscriptionSaleDiscount(sale) && isWithinSaleWindow(sale, now);
  }

  function discountedPrice(basePrice, explicitPrice, discountType, discountValue) {
    var salePrice = cents(explicitPrice);
    if (salePrice !== null) return salePrice;
    if (basePrice === null) return null;

    var value = number(discountValue);
    var discountAmount = null;

    if (discountType === 'percentage' && value !== null) {
      discountAmount = Math.round((basePrice * value) / 100);
    } else if (discountType === 'amount' && value !== null) {
      discountAmount = Math.round(value * 100);
    }

    if (discountAmount === null) return null;

    return Math.max(basePrice - discountAmount, 0);
  }

  function calculateTemporarySalePrice(basePrice, sale) {
    if (!sale) return null;
    return discountedPrice(basePrice, sale.price, sale.discountType, sale.discountValue);
  }

  function calculateSubscriptionSalePrice(basePrice, sale) {
    if (!sale) return null;
    return discountedPrice(
      basePrice,
      sale.subscriptionPrice,
      sale.subscriptionDiscountType,
      sale.subscriptionDiscountValue
    );
  }

  function discountPercent(basePrice, salePrice, discountType, discountValue) {
    var value = number(discountValue);
    if (discountType === 'percentage' && value !== null && value > 0) {
      return Math.round(value);
    }

    if (basePrice === null || basePrice <= 0 || salePrice === null || salePrice >= basePrice) {
      return 0;
    }

    return Math.round(((basePrice - salePrice) / basePrice) * 100);
  }

  function temporarySaleDiscountPercent(basePrice, salePrice, sale) {
    return discountPercent(basePrice, salePrice, sale && sale.discountType, sale && sale.discountValue);
  }

  function subscriptionSaleDiscountPercent(basePrice, salePrice, sale) {
    return discountPercent(
      basePrice,
      salePrice,
      sale && sale.subscriptionDiscountType,
      sale && sale.subscriptionDiscountValue
    );
  }

  function resolveVariantPrice(variant, now) {
    variant = variant || {};

    var basePrice = cents(variant.price_cents);
    var baseCompareAt = cents(variant.compare_at_price_cents);
    var sale = variant.temporarySalePrice || null;

    if (!isTemporarySaleActive(sale, now)) {
      return {
        isTemporarySale: false,
        price: basePrice,
        priceFormatted: variant.price || '',
        compareAtPrice: baseCompareAt,
        compareAtPriceFormatted: variant.compareAtPrice || '',
      };
    }

    var salePrice = calculateTemporarySalePrice(basePrice, sale);
    var saleCompareAt = cents(sale.compareAtPrice);

    if (salePrice === null) {
      return {
        isTemporarySale: false,
        price: basePrice,
        priceFormatted: variant.price || '',
        compareAtPrice: baseCompareAt,
        compareAtPriceFormatted: variant.compareAtPrice || '',
      };
    }

    if (saleCompareAt === null) {
      saleCompareAt = Math.max(basePrice || 0, baseCompareAt || 0) || null;
    }

    if (saleCompareAt !== null && saleCompareAt <= salePrice) {
      saleCompareAt = null;
    }

    return {
      isTemporarySale: true,
      price: salePrice,
      priceFormatted: sale.priceFormatted || variant.price || '',
      compareAtPrice: saleCompareAt,
      compareAtPriceFormatted: saleCompareAt ? sale.compareAtPriceFormatted || variant.compareAtPrice || '' : '',
      discountPercent: temporarySaleDiscountPercent(basePrice, salePrice, sale),
    };
  }

  function resolveSubscriptionPrice(variant, allocation, now) {
    variant = variant || {};
    allocation = allocation || {};

    var allocationPrice = cents(allocation.priceCents);
    var allocationCompareAt = cents(allocation.compareAtPriceCents);
    var sale = variant.temporarySalePrice || null;

    if (allocationCompareAt === null) {
      allocationCompareAt = cents(variant.price_cents);
    }

    var fallback = {
      isTemporarySale: false,
      price: allocationPrice,
      priceFormatted: allocation.price || '',
      compareAtPrice: allocationCompareAt,
      compareAtPriceFormatted: allocation.compareAtPrice || variant.price || '',
    };

    if (!isSubscriptionSaleActive(sale, now)) {
      return fallback;
    }

    var basePrice = cents(variant.price_cents);
    var salePrice = calculateSubscriptionSalePrice(basePrice, sale);

    if (salePrice === null) {
      return fallback;
    }

    var saleCompareAt = allocationPrice !== null && allocationPrice > salePrice ? allocationPrice : null;

    return {
      isTemporarySale: true,
      price: salePrice,
      priceFormatted: sale.subscriptionPriceFormatted || allocation.price || '',
      compareAtPrice: saleCompareAt,
      compareAtPriceFormatted: saleCompareAt !== null ? allocation.price || '' : '',
      discountPercent: subscriptionSaleDiscountPercent(basePrice, salePrice, sale),
      subscriptionTitle: sale.subscriptionTitle || '',
      subscriptionBenefits: Array.isArray(sale.subscriptionBenefits) ? sale.subscriptionBenefits : [],
      subscriptionBanner: sale.subscriptionBanner || '',
      hideFrequencyDiscount: sale.hideFrequencyDiscount === true,
    };
  }

  return {
    calculateSubscriptionSalePrice: calculateSubscriptionSalePrice,
    calculateTemporarySalePrice: calculateTemporarySalePrice,
    isSubscriptionSaleActive: isSubscriptionSaleActive,
    isTemporarySaleActive: isTemporarySaleActive,
    subscriptionSaleDiscountPercent: subscriptionSaleDiscountPercent,
    temporarySaleDiscountPercent: temporarySaleDiscountPercent,
    resolveSubscriptionPrice: resolveSubscriptionPrice,
    resolveVariantPrice: resolveVariantPrice,
  };
});
